import get from 'transmute/get';
export const getRecipientField = get('recipientField');
export const getActorId = get('actorId');
export const getSingleDeliveryIdentifier = get('singleDeliveryIdentifier');
export const getDeliveryIdentifier = get('deliveryIdentifier');
export const getName = get('name');